import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=b71b6886&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=b71b6886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71b6886",
  null
  
)

export default component.exports